import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';

import programTypeStatuses from 'data/program_type_statuses';

import useEnterprises from 'components/Common/Enterprises/Hooks/useEnterprises';

export default function Filters({
  enterpriseId, keyword, setKeyword, filterType, setFilterType, filterEnterprise, setFilterEnterprise,
}) {
  const enterprises = useEnterprises();

  return (
    <div className="invite_search">
      <Row>
        {enterpriseId === null && (
          <Col md={3}>
            <Select
              value={filterEnterprise}
              onChange={(item) => setFilterEnterprise(item)}
              placeholder={enterprises ? 'Enterprise' : 'Please, wait ...'}
              options={enterprises ? enterprises.map((item) => ({
                label: item.attributes.name,
                value: item.id,
              })) : []}
              isClearable
            />
          </Col>
        )}

        <Col md={4}>
          <form className="inviteSearch_form">

            <input
              type="text"
              placeholder="Search by Program Name"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              style={{ width: '100%' }}
            />
          </form>
        </Col>

        <Col md={3}>
          <Select
            value={filterType}
            onChange={(item) => setFilterType(item)}
            placeholder="Type"
            options={programTypeStatuses}
            isClearable
          />
        </Col>
      </Row>
    </div>
  );
}

Filters.propTypes = {
  enterpriseId: PropTypes.number,
  keyword: PropTypes.string.isRequired,
  setKeyword: PropTypes.func.isRequired,
  filterType: PropTypes.object,
  setFilterType: PropTypes.func.isRequired,
  filterEnterprise: PropTypes.object,
  setFilterEnterprise: PropTypes.func.isRequired,
};

Filters.defaultProps = {
  enterpriseId: null,
  filterType: null,
  filterEnterprise: null,
};
